import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { Input } from '@ets/design-system';

import { useFind } from './FindContext';

export type SearchProps = {
  resetFind: () => void;
  find: ({
    matchCase,
    wholeWord,
    query,
  }: {
    matchCase: boolean;
    wholeWord: boolean;
    query: string;
  }) => void;
};

const Search = ({ resetFind, find }: SearchProps) => {
  const intl = useIntl();

  const { matchCase, wholeWord } = useFind();

  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    if (inputValue === '') {
      resetFind();
    }
  }, [inputValue]);

  useEffect(() => {
    if (inputValue) {
      search();
    }
  }, [matchCase, wholeWord]);

  const search = () => {
    if (inputValue) {
      find({
        matchCase,
        wholeWord,
        query: inputValue,
      });
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      search();
    }
  };

  return (
    <Input
      placeholder={intl.formatMessage({ id: 'SEARCH_TEXT' })}
      size="m"
      prefix="search"
      width="22.25rem"
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      onKeyDown={handleKeyDown}
      onPrefixClick={search}
      testId="find-text"
    />
  );
};

export default Search;
